import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {TableErrorDetailWrapper} from '../Tables/TableErrorDetail'
import {ModuleErrorColumn} from '../../models'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  data: ModuleErrorColumn[]
  message: string
}

const ModalErrorTable: FC<Props> = ({show, setShow, data, message}) => {
  const handleClose = () => {
    setShow(false)
  }
  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-xl'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{message}</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>{show && <TableErrorDetailWrapper datos={data} />}</div>
      </div>
    </Modal>
  )
}

export {ModalErrorTable}
